import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

//DIRECTIVES
import { ToggleFullscreenDirective } from './directives/toggle-fullscreen.directive';
import { NumbersOnlyDirective } from './directives/numbers-only.directive';

import { PipeModule } from './pipes/pipe.module';
import { DragDropFileDirective } from './directives/drag-drop-file.directive';
import { SkeletonDirective } from './directives/skeleton.directive';
import { SkeletonRectComponent } from './directives/skeleton-rect.component';


@NgModule({
  exports: [
    ToggleFullscreenDirective,
    DragDropFileDirective,
    SkeletonDirective,
    SkeletonRectComponent,
    NumbersOnlyDirective

  ],
  declarations: [
    ToggleFullscreenDirective,
    DragDropFileDirective,
    SkeletonDirective,
    SkeletonRectComponent,
    NumbersOnlyDirective

  ],
  imports: [
    CommonModule,
    NgbModule,
    PipeModule
  ]
})
export class CoreModule { }
